<div class="row">
    <div class="col-12 text-center">You do not have the permission to view this page</div>
</div>
